import { Download, Share } from 'lucide-react';

import { DistributeOptionBuilderParams } from '@/sections/asset/types';
import type { DropdownOption } from '@/types/dropdown.types';

export const getAssetDistributeOptions = ({
  assets,
  handlers,
  onExportClick,
}: DistributeOptionBuilderParams): DropdownOption[] => {
  return [
    {
      label: 'Export Assets',
      icon: <Download className="size-4" />,
      onClick: onExportClick,
    },
    {
      label: 'Share URLs',
      icon: <Share className="size-4" />,
      onClick: () => handlers.handleShare(assets),
    },
  ];
};
